import { fetchDefaultHomeText } from './fetchHomeTextThunk';
export default fetchDefaultHomeText;
